module.exports = __webpack_public_path__ + "img/body-head.aaa24306.png";